import React from "react";
import "./Feed1.css";
import cor8 from "../assets/images/chosenlogo2.png";

function Feed1() {
  return (
    <div className="feed-wrapper">
      <h1 className="main-heading">Why Chosen IT Academy</h1>

      <div className="feed-container">
        {/* Left Side */}
        <div className="card-left" style={{ backgroundColor: "rgb(219 219 219)" }}>
          <div className="image-top">
            <img
              src={cor8}
              alt="Chosen IT Academy Logo"
              className="card-image"
            />
          </div>
          <div className="content-bottom">
            <ul className="inside-list">
              <li className="fli">You are Chosen</li>
              <li className="fli">Made for a purpose</li>
              <li className="fli">Born to win</li>
              <br />
              </ul>
              {/* <br /> */}
              <p className="feed-textl">
                The secret of living a life of excellence is merely a matter of
                thinking thoughts of excellence. Really, it's a matter of
                programming our minds with the kind of information that will set
                us free.
                <br /> - C. Swindoll
              </p>
           
          </div>
        </div>

        {/* Center Content */}
        <div className="center-content">
          <p className="feedp1">
            Chosen IT Academy is a one-of-a-kind organization that provides
            training and development for carefully chosen applicants who are in
            dire need of learning computer technologies to keep up with the
            latest trends in the IT sector as well as general personality
            development.
          </p>
          <p className="feedp2">
            Serving and raising the impoverished group is the only goal of this
            endeavour.
          </p>
          <ul className="inside-list">
            <p className="feedp3">
              The following advantages are assured if you receive training here:
            </p>
            <li className="fli">
              High-quality training that meets industry expectations at a
              reasonable cost
            </li>
            <li className="fli">Monitoring learning and guaranteeing progress</li>
            <li className="fli">
              Comprehensive development, including interview preparation and
              soft skills
            </li>
            <li className="fli">Support for candidates' placement</li>
          </ul>
        </div>

        {/* Right Side */}
        <div className="card-right" style={{ backgroundColor: "rgb(219 219 219)" }}>
          {/* <div className="image-bottom">
            <ol className="inside-list1">
              <h1 className="inside-listh1">Steps To Join</h1>
              <li className="fli1">Choose the Course</li>
              <li className="fli2">Choose the category Online/Offline/Hybrid</li>
              <li className="fli3">Register yourself for the course</li>
              <li className="fli4">Receive Intimation about the batch allocation</li>
              <li className="fli5">Pay the Registration fees</li>
              <li className="fli6">Join the Course</li>
            </ol>
          </div> */}
          <div class="list">
  <h2>Steps to Join</h2>
  <ul>
    <li><span>Choose the Course</span></li>
    <li><span>Choose the category Online/Offline/Hybrid</span></li>
    <li><span>Register yourself for the course</span></li>
    <li><span>Receive Intimation about the batch allocation</span></li>
    <li><span>Pay the Registration fees</span></li>
    <li><span>Join the Course</span></li>
  </ul>
</div>

        </div>
      </div>
    </div>
  );
}

export default Feed1;
